import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { useOpenTemplatePicker } from './useOpenTemplatePicker';
import AccountPicker from '../account-picker/AccountPicker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TemplateOpenerContext = /*#__PURE__*/React.createContext({
  setTemplateId: function setTemplateId() {// do nothing
  }
});
export var TemplateOpenerProvider = function TemplateOpenerProvider(props) {
  var children = props.children,
      getAnalytics = props.getAnalytics;

  var _useState = useState(null),
      templateId = _useState[0],
      setTemplateId = _useState[1];

  return /*#__PURE__*/_jsxs(TemplateOpenerContext.Provider, {
    value: {
      setTemplateId: setTemplateId
    },
    children: [children, /*#__PURE__*/_jsx(TemplateOpener, {
      getAnalytics: getAnalytics,
      templateId: templateId,
      setTemplateId: setTemplateId
    })]
  });
};
export var useTemplateOpener = function useTemplateOpener() {
  return React.useContext(TemplateOpenerContext);
};

var TemplateOpener = function TemplateOpener(_ref) {
  var templateId = _ref.templateId,
      setTemplateId = _ref.setTemplateId,
      getAnalytics = _ref.getAnalytics;

  var _useOpenTemplatePicke = useOpenTemplatePicker(templateId, setTemplateId, getAnalytics),
      _useOpenTemplatePicke2 = _slicedToArray(_useOpenTemplatePicke, 5),
      isAccountPickerVisible = _useOpenTemplatePicke2[0],
      onAccountPickerLoaded = _useOpenTemplatePicke2[1],
      onAccountPickerSubmit = _useOpenTemplatePicke2[2],
      onAccountPickerCancel = _useOpenTemplatePicke2[3],
      onAccountPickerError = _useOpenTemplatePicke2[4];

  return templateId ? /*#__PURE__*/_jsx(AccountPicker, {
    isVisible: isAccountPickerVisible,
    onLoaded: onAccountPickerLoaded,
    onSubmit: onAccountPickerSubmit,
    onCancel: onAccountPickerCancel,
    onError: onAccountPickerError
  }) : null;
};

export default TemplateOpener;